// Mirror OAUTH_CLIENT_KEY_{MIN,MAX}_LIFETIME_DAYS, OAUTH_CLIENT_MAX_ACTIVE_KEYS
// and OAUTH_CLIENT_MIN_RSA_MODULUS_BITS in taktile-api. Duplicated so the form
// refuses out-of-range input before the request; the backend stays the
// authority and answers 422 either way.
export const KEY_LIFETIME_MIN_DAYS = 30;
export const KEY_LIFETIME_MAX_DAYS = 365;
export const MAX_ACTIVE_KEYS = 2;
export const MIN_RSA_MODULUS_BITS = 2048;

export const PROXY_TOKEN_ENDPOINT_PATH = "/cp-proxy/api/v1/oauth/token";

export const proxyTokenEndpointFor = (baseUrl: string): string =>
  `https://${baseUrl}${PROXY_TOKEN_ENDPOINT_PATH}`;

export const keyLifetimeDaysError = (value: string): string | undefined => {
  if (value === "") return undefined;

  const parsed = Number(value);
  if (!Number.isInteger(parsed)) {
    return "The lifetime must be a whole number of days";
  }
  if (parsed < KEY_LIFETIME_MIN_DAYS) {
    return `The lifetime must be at least ${KEY_LIFETIME_MIN_DAYS} days`;
  }
  if (parsed > KEY_LIFETIME_MAX_DAYS) {
    return `The lifetime must be at most ${KEY_LIFETIME_MAX_DAYS} days`;
  }
  return undefined;
};
